import { Compass } from "lucide-react";
import { Link } from "react-router-dom";
import { Empty, useDocumentTitle } from "../components/ui";
import { useT } from "../i18n";

export function NotFoundPage() {
  const t = useT();
  useDocumentTitle(t("Không tìm thấy", "Not found"));
  return (
    <Empty icon={Compass} title={t("Không tìm thấy trang này", "Page not found")}>
      <p>{t("Liên kết có thể đã thay đổi.", "The link may have changed.")}</p>
      <Link className="btn primary" to="/">{t("Về trang chủ", "Back to home")}</Link>
    </Empty>
  );
}
